import { render, staticRenderFns } from "./MeasureVerificationEscalationGroups.vue?vue&type=template&id=54902a7e"
import script from "./MeasureVerificationEscalationGroups.vue?vue&type=script&lang=ts"
export * from "./MeasureVerificationEscalationGroups.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports